<template>
  <div>
    <!-- <Modal
      :options="{ footer: true }"
      modalId="executeWorklog"
      title="Dodaj task za radni nalog"
      v-on:closeWorklog="closeWorklog"
    >
      <ExecuteWorklogTask />
    </Modal> -->

    <Modal
      modalId="generatePdf"
      v-if="selected.length > 0 && selected[0].taskInProgress"
      ><component :is="'generate-pdf-template'" :data="selected[0]"></component>
    </Modal>
    <div class="mb-3">
      <h1 class="h2">Dashboard</h1>
    </div>
    <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          @click="
            () => {
              $router.push('/dashboard');
            }
          "
          >Aktivni tiketi</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          @click="
            () => {
              $router.push('/dashboard/closed-worklogs');
            }
          "
          >Zakljuceni tiketi</a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="home"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <div>
          <div class="row">
            <div class="col-md-12">
              <button class="btn btn-primary" @click="createWorklog()">
                Novi nalog
              </button>
              <button
                type="button"
                class="btn btn-link"
                v-if="selected.length != 0 && selected[0].status != 'Closed'"
                @click="executeWorklog"
              >
                Aktiviraj
              </button>
              <!-- <button
                type="button"
                class="btn btn-link"
                v-if="selected.length != 0 && selected[0].status != 'Closed'"
                @click="editWorklog"
              >
                Izmijeni
              </button> -->
              <button
                type="button"
                class="btn btn-link"
                v-if="selected.length != 0 && selected[0].status === 'Active'"
                @click="closeWorklog"
              >
                Zakljuci
              </button>
              <button
                type="button"
                class="btn btn-link"
                v-if="selected.length != 0 && selected[0].status != 'New'"
                @click="printGrid"
              >
                Stampaj
              </button>
              <button
                type="button"
                class="btn btn-link"
                v-if="selected.length != 0 && selected[0].status != 'Closed'"
                @click="deleteWorklog"
              >
                Obrisi
              </button>

              <Modal modalId="deleteWorklog" v-if="selected.length > 0">
                <p>
                  Da li ste sigurni da zelite obrisati radni nalog broj:
                  {{ selected[0].worklogNumber }} ?
                </p>
                <button class="btn btn-danger" @click="commitDelete">
                  Da
                </button>
                <button class="btn btn-primary" @click="close">Ne</button>
              </Modal>
            </div>
          </div>
          <div class="row pl-3 pr-3 mt-3">
            <div id="vueapp" class="vue-app" v-if="getWorklogs.length > 0">
              <v-data-table
                v-model="selected"
                :headers="columns"
                :items="getWorklogs"
                :single-select="true"
                :sort-by="['dateTicketWasOpened', 'dateTicketWasClosed']"
                :sort-desc="[true, true]"
                item-key="worklogNumber"
                show-select
                class="elevation-1"
              >
                <template v-slot:item.worklogNumber="{ item }">
                  <span>{{ item.worklogNumber }}</span>
                </template>
                <template v-slot:item.dateTicketWasOpened="{ item }">
                  <span>{{ new Date(item.dateTicketWasOpened) | moment }}</span>
                </template>
                <template v-slot:item.dateTicketWasClosed="{ item }">
                  <span v-if="item.dateTicketWasClosed !== 0">{{
                    new Date(item.dateTicketWasClosed) | moment
                  }}</span>
                  <span v-else> Tiket nije jos zatvoren </span>
                </template>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Edit
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </div>
            <div v-else>
              <h2>Trenutno nemamo kreiranih naloga. Kreiraj radni nalog !</h2>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import Modal from "@/components/Common/Modal";
import ExecuteWorklogTask from "@/components/Worklog/ExecuteWorklogTask";
import GeneratePdfTemplate from "@/components/Worklog/GeneratePdfTemplate.vue";
import moment from "moment";
/*eslint-disable */
export default {
  components: {
    Modal,
    ExecuteWorklogTask,
    "generate-pdf-template": GeneratePdfTemplate
  },
  mounted() {
    this.$store.dispatch("takeAllClients");
    this.$store.dispatch("getAllAdminAccounts");
    this.$store.dispatch("getOptions");
    this.$store.dispatch("useWorklogKey");
    this.getLogs();
  },
  data() {
    return {
      test: {},
      selected: [],
      selectedID: false,
      target: "#target",
      exportSettings: {
        fileName: "ExcelExport.xlsx"
        // proxyURL: "https://demos.telerik.com/kendo-ui/service/export"
      },
      columns: [
        {
          value: "worklogNumber", // create a column bound to the "name" field
          text: "Sifra radnog naloga"
        },
        {
          value: "customer",
          text: "Klijent"
        },
        {
          value: "typeOfProblem",
          text: "Opis problema"
        },
        {
          value: "problemDescription",
          text: "Opis problema"
        },
        {
          value: "dateTicketWasOpened",
          text: "Datum otvaranja naloga"
        },

        {
          value: "contactPerson",
          text: "Kontakt osoba"
        },
        {
          value: "phoneNumber",
          text: "Broj telefona"
        },

        {
          value: "dateTicketWasClosed",
          text: "Datum zatvaranja tiketa"
        },
        {
          value: "status",
          text: "Status"
        }
      ]
    };
  },
  watch: {
    test: {
      handler() {
        // this.getLogs();
      }
      // deep: true
    }
  },
  methods: {
    getLogs(e) {
      this.$store.dispatch("getAllWorklogs", { closedTickets: false });
      // console.log("TEST", e);
      console.trace();
      return;
    },
    createWorklog() {
      this.$router.push("/create-worklog");
    },
    executeWorklog() {
      this.$store.commit("setExecuteData", this.selected[0]);
      this.$router.push("/worklog-view");
      // $("#executeWorklog").modal("toggle");
    },
    closeWorklog(value) {
      this.selected[0].dateTicketWasClosed = Date.now();
      this.$store.dispatch("closeWorklog", this.selected[0]).then(() => {
        $("#executeWorklog").modal("hide");
        this.selected = [];
      });
    },
    printGrid() {
      $("#generatePdf").modal("toggle");
    },
    editWorklog() {
      this.$router.push("/edit-worklog");
    },
    deleteWorklog() {
      $("#deleteWorklog").modal("toggle");
    },
    commitDelete() {
      this.$store.dispatch("deleteWorklog", this.selected[0].worklogNumber);
      this.close();
    },
    close() {
      $("#deleteWorklog").modal("hide");
    },
    goToWorklog(data) {
      console.log(data);
      this.$store.commit("setTempWorklog", data);
      this.$router.push("/worklog-view");
    }
  },
  computed: {
    getWorklogs() {
      return this.$store.getters.getWorklogs;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY HH:MM");
    }
  }
};
</script>
